import { observable, makeObservable, action } from 'mobx';

/**
 * @typedef {{
 *    tab: string
 *    type: string,
 *    value: string | object,
 * }} Option
 */

/**
 * @typedef {{
 *  page?: string,
 *  options: Option[]
 * }} FilterStoreProps
 */
export class FilterStore {
  page = observable.box('');

  options = observable([]);

  /** @param {any} options */
  setOptions(options) {
    if (this) this.options = options;
  }

  /** @param {any} page */
  setPage(page) {
    if (this) this.page = page;
  }

  /** @param {string[]} types */
  clearFilterbyType(types) {
    /** @type {Option[]} */
    const options = this.options.filter(/** @param {Option} f */(f) => !types.includes(f.type));
    this.setOptions(options);
  }

  reset() {
    this.setPage('');
    this.setOptions([]);
  }

  constructor() {
    makeObservable(this, {
      page: observable,
      options: observable,
      setPage: action,
      setOptions: action,
      clearFilterbyType: action
    });
  }
}
